import React from 'react';
import './App.css';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { Button, Paper } from '@material-ui/core';
import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/styles.css';
import AwesomeSliderStyles from 'react-awesome-slider/dist/custom-animations/cube-animation.css';
import FadeIn from '../FadeIn/FadeIn'
class App extends React.Component {

  renderImages() {
    let amountOfImages = 33;
    let result = [];
    for (let i = 1; i <= amountOfImages; i++) {
      result.push(
        <FadeIn key={i} height={100}>
          {onLoad =>
            <img style={{ width: '100%', height: undefined,aspectRatio: 2 }}  onLoad={onLoad} src={"/images/portfolio-" + i + ".jpg"} />
          }
        </FadeIn>
      )
    }
    return result;
  }
  render() {
    return (
      <Grid container className="App" justify="center" alignItems="center" height="100%">
        <Grid item xs={12}>
        
        <Typography variant="h6" style={{backgroundColor: '#fff', color:'#1976d2', opacity: .75}}>
           [ Work In Progress ]
        </Typography>
        
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h2" className="FadeIn Orator">
            Steven Grullón
        </Typography>
          <Grid item xs={12} className="FadeInDelay">
            <Button className="Orator" variant="outlined" color="default" target="_blank" href="https://drive.google.com/file/d/1bka5Qij6S0MDAgSjwOxwf4oGcS1fncpP/view?usp=sharing">
              Download Portfolio
        </Button>
          </Grid>
        </Grid>
        <Grid className="Portfolio" item xs={12} lg={6} xl={9}>
            {this.renderImages()}
        </Grid>
      </Grid>
    );
  }
}
export default App;